import { Category } from './category';

export class Image {
  id: number;
  category: Category;
  category_id: number;

  position: number;
  publish: Date;
  publish_pretty: string;
  unpublish: Date;
  state: number;
  visible: boolean;
  show_on_frontpage: boolean;
  show_on_categorypage: boolean;
  file_name: string;
  file_name_original: string;

  file_size_original: number;
  file_size_large: number;
  file_size_middle: number;
  file_size_small: number;

  width_original: number;
  height_original: number;
  width_large: number;
  height_large: number;
  width_middle: number;
  height_middle: number;
  width_small: number;
  height_small: number;

  title: string;
  description: string;
  note: string;
  copyright_text: string;
  hits: number;
  exif: string;
  iptc: string;
  old_id: number;
  reliability: number;

  keyword_categories: any[];

  created: Date;
  modified: Date;
  prev: Image;
  next: Image;

  public getKeywords() {
    return this.keyword_categories[8].map(keyword => keyword.keyword);
  }

}
